const homepage = {
  slug: 'f/homepage',
  getFmArticles: () => `${homepage.slug}/articles`,
  getDirectoryCategories: () => `${homepage.slug}/directory/categories`,
  getDirectoryCompanies: () => `${homepage.slug}/directory/companies`,
  getHomepageEvents: () => `${homepage.slug}/upcoming-events`
}

export default homepage
